import { useState } from "react";
import { PageStatus } from "./useInterviewUpdater";

export default function useFormButtons(
    setFormData = () => { },
    trigger = () => { },
    getValues = () => { }
) {
    const [pageStatus, setPageStatus] = useState(PageStatus.Started);
    const [exitAfterSave, setExitAfterSave] = useState(false);

    function onSubmit(formData) {
        setFormData({ ...formData });
        setPageStatus(PageStatus.Completed);
    }

    function onSaveAndExit() {
        trigger().then(validationPassed => {
            if (validationPassed) {
                setPageStatus(PageStatus.Started);
                setExitAfterSave(true);
                setFormData(getValues());
            }
        });
    };

    return {
        pageStatus,
        exitAfterSave,
        onSubmit,
        onSaveAndExit
    };
}